import { SimulatedTag } from '@hive/ui';
import type { ScreenTelemetry } from '../api/client';
import { usePreview } from '../api/hooks';

/**
 * The screen's real, most recent frame. Simulated screens and screens without a preview
 * get a clearly labelled placeholder: never a fake image.
 */
export function ScreenThumb({ screen, large }: { screen: ScreenTelemetry; large?: boolean }) {
  const url = usePreview(screen.id, screen.preview?.capturedAt);
  const np = screen.nowPlaying;
  const overlay = np?.score ? `${np.score}${np.clock ? ` · ${np.clock}` : ''}` : np?.kind === 'loop' ? 'Sponsor loop' : undefined;
  const placeholder =
    screen.source === 'simulated'
      ? 'Simulated screen · no preview'
      : screen.status === 'offline'
        ? 'Player offline · no signal'
        : screen.status === 'unpaired'
          ? 'No player paired'
          : 'Waiting for the first preview frame';
  return (
    <div className={`mc-thumb${large ? ' mc-thumb--large' : ''} mc-thumb--${screen.status}`}>
      {url && screen.status === 'online' ? <img src={url} alt={`Live preview of ${screen.name}`} /> : <span className="mc-thumb__placeholder">{placeholder}</span>}
      {overlay && screen.status === 'online' && (
        <span className="mc-thumb__chip">
          {overlay}
          {np?.scoreSource === 'simulated' && np.score && <SimulatedTag title="Score and clock are simulated" />}
        </span>
      )}
    </div>
  );
}
